import React from 'react';
import IconButtonBase from './IconButtonBase';
import { TIconButton } from './types';

const DestructiveGhost = ({ as = 'button', ...rest }: TIconButton) => (
  <IconButtonBase {...rest} as={as} kind="destructive-ghost" />
);

export default DestructiveGhost;
